<template>
  <main>
    <div class="blog-entery">
      <div class="blog-entery__cover m-b-30" v-bind:style="{ backgroundImage: 'url(' + pageInfo.feature_image_url + ')' }">
        <div class="blog-entery__cover__title">
          <div class="title align-center">
            <h1>{{ pageInfo.title }} - {{ $t("websiteName") }}</h1>
            <h6>{{ pageInfo.source_name }} - {{ pageInfo.date }}</h6>
          </div>
        </div>
      </div>
      <div class="container blog-entery__content row">

        <div class="col-md-3 col-md-offset-1 col-xs-12">
          <div class="social-sharing-container">

            <div class="blog-entery__author" v-if="pageInfo.author">

              <small>{{ $t("global.by") }}</small>
              <h5 class="author-name">{{ pageInfo.author.name }}</h5>
              <p  class="author-bio">{{ pageInfo.author.bio }}</p>
              <a target="_blank" rel="noopener" class="icon-link" v-if="pageInfo.author.twitter_url != ''" v-bind:href="pageInfo.author.twitter_url"><i class="fa fa-twitter" aria-hidden="true"></i></a>
              <a target="_blank" rel="noopener" class="icon-link" v-if="pageInfo.author.linkedin_url != ''" v-bind:href="pageInfo.author.linkedin_url"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
            </div>

              <small>{{ $t("global.share") }}</small>
              <social-sharing :url="pageUrl"
                          :title="pageTitle"
                          :description="pageInfo.meta_twitter_description"
                          hashtags="softcareio"
                          twitter-user="softcareio"
                          inline-template>
                <div class="social-sharing">
                  <network class="share-network" network="facebook">
                    <i class="fa fa-fw fa-facebook"></i> {{ $t("global.facebook") }}
                  </network>
                  <network class="share-network" network="linkedin">
                    <i class="fa fa-fw fa-linkedin"></i> {{ $t("global.linkedIn") }}
                  </network>
                  <network class="share-network" network="twitter">
                    <i class="fa fa-fw fa-twitter"></i> {{ $t("global.twitter") }}
                  </network>
                </div>
              </social-sharing>
            </div>
        </div>

        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-1 col-xs-12" v-html="pageInfo.content"></div>

      </div>
    </div>
  </main>
</template>

<script>
import Vue from "vue";
import SocialSharing from "vue-social-sharing";

Vue.use(SocialSharing);

export default {
	name: "BlogDetails",
	data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			params: this.$route.params.slug,
			pageUrl: location.href
		};
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{ itemprop: "name", content: this.pageInfo.meta_og_description },
				{ itemprop: "description", content: this.pageInfo.meta_og_description },
				{ name: "og:title", content: this.pageInfo.meta_og_title },
				{ name: "og:description", content: this.pageInfo.meta_og_description },
				{ name: "og:url", content: this.pageInfo.meta_url },
				{ name: "og:site_name", content: this.pageInfo.meta_twitter_site },
				{ name: "og:type", content: this.pageInfo.meta_og_type },
				{ name: "og:image", content: this.pageInfo.meta_og_image_url },

				{ name: "twitter:card", content: this.pageInfo.meta_twitter_card },
				{ name: "twitter:site", content: this.pageInfo.meta_twitter_site },
				{ name: "twitter:title", content: this.pageInfo.meta_twitter_title },
				{
					name: "twitter:description",
					content: this.pageInfo.meta_twitter_description
				},
				{
					name: "twitter:creator",
					content: this.pageInfo.meta_twitter_creator
				},
				{ name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
			]
		};
	},
	created() {
		this.getContent();
	},
	methods: {
		getContent() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/news?filter[slug]=" + this.params)
				.then(function(response) {
					this.pageInfo = response.body;
					this.pageTitle = this.pageInfo.title;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/BlogDetails.vue